import React from "react";
import deleteIcon from "../../styles/svg/adminWorkflowDelete.svg";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";

export const DeleteIcone = React.memo(({ height, width, ...other }) => {
  return (
    <img
      src={deleteIcon}
      alt="Delete Icon"
      style={{ height: height, width: width, cursor: "pointer" }}
      {...other}
    />
  );
  });

export const EditIcone = React.memo(({ height, width, ...other }) => {
  return (
    <ModeEditOutlinedIcon
      alt="edit Icon"
      style={{ height: height, width: width, cursor: "pointer" }}
      {...other}
    />
  );
});
